import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { SectionType } from '../typings'
import { selectAllSalesFunnelStages } from '../slice'
import type { ENTITY_TYPES } from '@sales-center/common'

export const useSelectFunnelStagesByTypes = (
  funnelIds: number[],
  type: SectionType | ENTITY_TYPES,
) => {
  const stages = useSelector(selectAllSalesFunnelStages)
  const filtered = useMemo(
    () =>
      stages.filter(
        (x) =>
          x.sectionType.toLowerCase() === type.toLowerCase() &&
          (funnelIds === undefined || funnelIds.includes(x.salesFunnelId)),
      ),
    [funnelIds, type, stages],
  )
  return filtered
}
